import React, {useState, useEffect} from 'react';
import OtpInput from './OtpInput';
import {
  PAGES, PIN_NUMBER_LENGTH, OTP_TIME_EXPIRED,
  SECONDS_TO_RESEND_OTP, SECONDS_TO_SEND_OTP, SECONDS_TO_SHOW_OTP_WARNING, LINKS
} from '../constants';
import { connect } from "react-redux";
import Selectors from "../selectors";
import {
  createAccountAction,
  resendVerificationSmsAction,
  setResendOtpAvailableAction,
  updateCurrentPageAction, updateOtpCountDownMessageAction, updateOtpExpiredTimeAction
} from "../state/registration";
import {

} from "../constants";
import {OTP_RESEND_SESSION} from "../constants/errorMessagesConstants";

const stateToProps = (state) => ({
  isLoading: Selectors.getIsLoadingStepSms(state),
  emailData: Selectors.getEmailData(state),
  usernameData: Selectors.getUsernameData(state),
  passwordData: Selectors.getPasswordData(state),
  firstNameData: Selectors.getFirstNameData(state),
  surnameData: Selectors.getSurnameData(state),
  statesData: Selectors.getStatesData(state),
  phoneData: Selectors.getPhoneData(state),
  resendAvailable: Selectors.resendAvailable(state),
  otpMessage: Selectors.getOtpMessage(state),
  otpCountDownMessage: Selectors.getOtpCountDownMessage(state),
  otpError: Selectors.getOtpError(state),
  isDesktop: Selectors.isDesktop(state),
  promocodeData: Selectors.getPromocodeData(state),
  birthdayData: Selectors.getBirthdayData(state),
  pendingRegistrationId: Selectors.getPendingRegistrationId(state),
  btagValue: Selectors.getBtagValue(state),
  otpExpiredAttempts: Selectors.getOtpExpiredAttempts(state),
  otpExpiredTime: Selectors.getOtpExpiredTime(state),
});

const actionsToProps = (dispatch) => ({
  updateCurrentPage: (data) => dispatch(updateCurrentPageAction(data)),
  resendVerificationSms: (data) => dispatch(resendVerificationSmsAction(data)),
  setResendOtpAvailable: (data) => dispatch(setResendOtpAvailableAction(data)),
  updateCountDownMessage: (data) => dispatch(updateOtpCountDownMessageAction(data)),
  updateOtpExpiredTime: (data) => dispatch(updateOtpExpiredTimeAction(data)),
  createAccount: (data) => dispatch(createAccountAction(data)),
});

const useComponentDidMount = onMountHandler => {
  React.useEffect(() => {
    onMountHandler();
  }, []);
};

const SmsStep = props =>  {
  const [seconds, setCountDown] = useState(SECONDS_TO_SEND_OTP);
  const [otpInterval, setOtpInterval] = useState(null);
  const [otpValue, setOtpValue] = useState('');

  useComponentDidMount(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (props.otpExpiredAttempts === false && props.otpExpiredTime === false) {
      setNewInterval();
    }
  });

  const setNewInterval = () => {
    const currDate = (new Date().getTime());
    const targetDate = currDate + (SECONDS_TO_SEND_OTP * 1000)
    const countDownDate = new Date(targetDate).getTime();
    setOtpInterval(setInterval(() => {
      setCountDown(Math.floor((countDownDate - new Date().getTime()) / 1000));
    }, 1000));
  }

  useEffect(() => {
    if (seconds === SECONDS_TO_RESEND_OTP) {
      props.setResendOtpAvailable(true);
    }

    if (!props.isLoading) {
      if (props.otpError === true) {
        clearInterval(otpInterval);
      } else if (props.otpExpiredAttempts === true) {
        clearInterval(otpInterval);
        props.updateOtpExpiredTime({
          otpExpiredTime: true,
          otpCountDownMessage: '',
        });
        // props.updateCountDownMessage('');
      } else if (seconds <= 0 || props.otpExpiredTime === true) {
        clearInterval(otpInterval);
        props.updateOtpExpiredTime({
          otpExpiredTime: true,
          otpCountDownMessage: OTP_TIME_EXPIRED,
        });
        // props.updateCountDownMessage(OTP_TIME_EXPIRED);
      } else if (seconds < SECONDS_TO_SHOW_OTP_WARNING) {
        props.updateCountDownMessage(OTP_RESEND_SESSION.replace('{time}', timer(seconds)));
      }
    }
  });

  const timer = sec => {
    const sec_num = parseInt(sec);
    let minutes = Math.floor(sec_num / 60);
    let seconds = sec_num - (minutes * 60);
    if (minutes < 10) { minutes = `0${minutes}`; }
    if (seconds < 10) { seconds = `0${seconds}`; }
    return `${minutes}:${seconds}`;
  };

  const handleOtpChange = (otp) => setOtpValue(otp);

  const onResendOtpEvent = () => {
    if (!props.isLoading && props.resendAvailable) {
      setOtpValue('');
      
      props.resendVerificationSms({
        mobile: props.phoneData.value,
        pendingRegistrationId: props.pendingRegistrationId
      });

      if (otpInterval != null) {
        clearInterval(otpInterval);
      }
      setNewInterval();
    }
  }

  const onSubmit = () => {
    const params = {
      email: props.emailData.value,
      firstname: props.firstNameData.value,
      lastname: props.surnameData.value,
      day: props.birthdayData.day,
      month: props.birthdayData.month,
      year: props.birthdayData.year,
      username: props.usernameData.value,
      password: props.passwordData.value,
      state: props.statesData.value,
      mobile: `234${props.phoneData.value}`,
      device: props.isDesktop ? 'desktop' : 'mobile',
      pinCode: parseInt(otpValue),
      queryParam: document.location.search.slice(1, document.location.search.length)
    };

    if (props.promocodeData.value !== '') {
      params["promotionCode"] = props.promocodeData.value;
    }

    if (props.btagValue !== '') {
      params["btag"] = props.btagValue;
    }

    if (props.pendingRegistrationId !== 0) {
      params["pendingRegistrationId"] = props.pendingRegistrationId;
    }

    params["source"] = "web2";

    props.createAccount(params);
  }

  return (
    <div>
      <div className="registration-form">
        <div className="registration-code">
          <p className="registration-code__p">Please enter the 4-digit OTP code we have sent to:</p>
          <p className="registration-code__p">
            {`+234${props.phoneData.value}`}
            .
            <a onClick={() => { props.updateCurrentPage(PAGES.SECOND_STEP); }}
               style={{ cursor: 'pointer' }} className="registration-code__link">
              Wrong Number?
            </a>
          </p>
          <div className="code">
            <OtpInput
              value={otpValue}
              onChange={handleOtpChange}
              numInputs={4}
              shouldAutoFocus
              containerStyle="code__boxes"
              inputStyle="code__input"
              className="code__box"
              errorStyle="error"
              correctStyle="correct"
              isDisabled={props.isLoading || seconds <= 0 || props.otpExpiredAttempts === true || props.otpExpiredTime === true}
              hasErrored={props.otpMessage !== '' || props.otpCountDownMessage !== ''}
            />

            {props.otpCountDownMessage !== ''
                && (
                    <div className="code__message">
                      <p>{props.otpCountDownMessage}</p>
                    </div>
                )}

            {props.otpMessage !== ''
              && (
                <div className="code__message">
                  <p>{props.otpMessage}</p>
                </div>
              )}
          </div>
          <div className="registration-code__p">
            Didn&apos;t receive the OTP code?
            <a style={props.resendAvailable ? { cursor: 'pointer' } : { cursor: 'pointer', color: 'gray' }}
              onClick={onResendOtpEvent} className="registration-code__link"
            >
              Resend OTP
            </a>
          </div>
          <button
            className={`registration-code__confirm ${props.isLoading ? 'btn-loader' : ''}`}
            type="button"
            disabled={props.isLoading || otpValue.length !== PIN_NUMBER_LENGTH || seconds <= 0 || props.otpExpiredAttempts === true || props.otpExpiredTime === true}
            onClick={onSubmit}
          >
            Verify and Create Account
          </button>
          <div className="registration-code__p mt30">Still having trouble ? Please contact our</div>
          <a style={{ cursor: 'pointer' }} className="registration-code__link visible-s" href={LINKS.contact_us} target="_blank" rel="noreferrer"> Customer Support</a>
          <a style={{ cursor: 'pointer' }} className="registration-code__link hidden-s" onClick={() => { window.open(LINKS.contact_us, '_blank', 'width=1216,height=867'); }}>Customer Support</a>
        </div>
      </div>
    </div>
  );
}

export default connect(
    stateToProps,
    actionsToProps
)(SmsStep);
